// removed by extract-text-webpack-plugin
module.exports = {"paginationItem":"paginationItem___3AWhr","paginationItemActive":"paginationItemActive___3N9lB","inlineBlock":"inlineBlock___2TQP8","jumper":"jumper___1qoVy"};